import Axios from 'axios'

export default function(req) {
    return new Promise(resolve=>{
        Axios.request({
            url:req.url,
            method:req.method||'GET',
            data:req.data||{},
            params:req.params||{},
            baseURL:'/apis'
        }).then(({data})=>{
            resolve(data)
        }).catch(e=>{
            resolve({code: 500, message: '后端接口问题，请联系后端进行处理'})
        })
    })
}



// WEBPACK FOOTER //
// ./src/api/ajax.js